import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

import { EarlyPayoutAcceptance } from '../model/early-payout';
import { IUserBettingSettings } from '../model/user.models';

export function mapEarlyPayoutAcceptance(settings: IUserBettingSettings): Nullable<EarlyPayoutAcceptance.Any | EarlyPayoutAcceptance.Higher> {
    if (settings.earlyPayoutAcceptanceMode !== EarlyPayoutAcceptance.Any && settings.earlyPayoutAcceptanceMode !== EarlyPayoutAcceptance.Higher) {
        return null;
    }

    return settings.earlyPayoutAcceptanceMode === EarlyPayoutAcceptance.Any ? EarlyPayoutAcceptance.Any : EarlyPayoutAcceptance.Higher;
}
